(() => {
  const u = (e) => {
      var t = e.querySelectorAll(".slideshow__video video");
      e.swiper && e.swiper.initialized
        ? t.forEach((e) => {
            // e.closest(".swiper-slide-visible") ? e.play() : e.pause();
          })
        : e.closest('[data-slide-count="1"]') &&
          t.forEach((e) => {
            e.play();
          });
    },
    t = (c) => {
      c &&
        c.classList.contains("section-slideshow") &&
        new IntersectionObserver((e) => {
          e.forEach((e) => {
            if (e.isIntersecting) {
              e = c.querySelector(".slideshow");
              if (e) {
                var t = e.querySelector(".swiper-button-prev"),
                  i = e.querySelector(".swiper-button-next"),
                  a = { speed: 800, autoHeight: !1, allowTouchMove: !0, watchSlidesProgress: !0, preventInteractionOnTransition: !0 };
                const r = (e) => {
                  var t = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
                    i = e.activeIndex,
                    i = e.slides[i];
                  let a = 0,
                    r;
                  e.el.parentNode.classList.contains("slideshow__swiper--simple") && ((r = e.el.parentNode), (a = 990)),
                    (e.el.classList.contains("slideshow__swiper--overlay") || e.el.classList.contains("slideshow__swiper--grid")) && (a = 0);
                  e = [e.navigation.nextEl, e.navigation.prevEl, e.pagination.el, ...(r ? [r] : [])];
                  if (t >= a) {
                    const o = i.dataset.colorScheme;
                    e.forEach((t) => {
                      if (t) {
                        let e = t.getAttribute("class");
                        (e = e.replace(/color-background-\d+/g, "")), t.setAttribute("class", e), t.classList.add(o);
                      }
                    });
                  } else
                    e.forEach((t) => {
                      if (t) {
                        let e = t.getAttribute("class");
                        (e = e.replace(/color-background-\d+/g, "")), t.setAttribute("class", e);
                      }
                    });
                };
                if (
                  ("true" === e.getAttribute("data-autoplay") && (a.autoplay = { disableOnInteraction: !0 }),
                  "true" === e.getAttribute("data-pagination") && (a.pagination = { el: ".swiper-pagination", type: "bullets", clickable: !1 }),
                  "true" === e.getAttribute("data-navigation") && (a.navigation = { nextEl: i, prevEl: t }),
                  "true" === e.getAttribute("data-parallax") && "grid" !== e.getAttribute("data-layout") && (a.parallax = !0),
                  "true" === e.getAttribute("data-enable-loop") && (a.loop = !0),
                  "grid" === e.getAttribute("data-layout") && (a.breakpoints = { 750: { slidesPerView: "auto" } }),
                  1 < Number(e.getAttribute("data-slide-count")))
                )
                  if ("simple" === e.getAttribute("data-layout")) {
                    var i = e.querySelector(".slideshow__swiper--text");
                    const o = e.querySelector(".slideshow__swiper--media");
                    if (i && o) {
                      const s = new Swiper(i, a);
                      var t = new Swiper(o, { ...a, autoplay: !1, pagination: !1, navigation: !1, parallax: !1 });
                      ((s.controller.control = t).controller.control = s),
                        r(s),
                        s.on("beforeTransitionStart", function () {
                          r(this);
                        }),
                        t.on("beforeTransitionStart", function () {
                          r(s);
                        }),
                        t.on("slideChange", function () {
                          u(o);
                        });
                    }
                  } else if ("overlay" === e.getAttribute("data-layout")) {
                    const n = e.querySelector(".slideshow__swiper--overlay");
                    n &&
                      ((i = new Swiper(n, { ...a, effect: "creative", creativeEffect: { prev: { translate: [0, 0, -400] }, next: { translate: ["100%", 0, 0] } } })),
                      r(i),
                      i.on("beforeTransitionStart", function () {
                        r(this);
                      }),
                      i.on("slideChange", function () {
                        u(n);
                      }));
                  } else if ("grid" === e.getAttribute("data-layout")) {
                    const l = e.querySelector(".slideshow__swiper--grid");
                    l &&
                      ((t = new Swiper(l, a)),
                      r(t),
                      t.on("beforeTransitionStart", function () {
                        r(this);
                      }),
                      t.on("slideChange", function () {
                        u(l);
                      }));
                  }
              }
            }
          });
        }).observe(c);
    },
    i = (e) => {
      if (e && e.classList.contains("section-slideshow")) {
        const a = e.querySelector(".slideshow");
        let i;
        a && "simple" === a.getAttribute("data-layout")
          ? (i = e.querySelector(".slideshow__swiper--media"))
          : a && "overlay" === a.getAttribute("data-layout")
          ? (i = e.querySelector(".slideshow__swiper--overlay"))
          : a && "grid" === a.getAttribute("data-layout") && (i = e.querySelector(".slideshow__swiper--grid")),
          new IntersectionObserver((e) => {
            e.forEach((e) => {
              var t;
              e.isIntersecting
                ? i && (u(i), i.swiper) && "true" === a.getAttribute("data-autoplay") && i.swiper.autoplay.resume()
                : i &&
                  ((e = i),
                  (t = e.querySelectorAll(".slideshow__video video")),
                  e.swiper && e.swiper.initialized
                    ? t.forEach((e) => {
                        e.pause();
                      })
                    : e.closest('[data-slide-count="1"]') &&
                      t.forEach((e) => {
                        e.play();
                      }),
                  i.swiper) &&
                  "true" === a.getAttribute("data-autoplay") &&
                  i.swiper.autoplay.pause();
            });
          }).observe(e);
      }
    };
  t(document.currentScript.parentElement),
    i(document.currentScript.parentElement),
    document.addEventListener("shopify:section:load", function (e) {
      t(e.target), i(e.target);
    });
})();
